import * as React from 'react';
import Form from 'src/components/controls/forms/Form';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import FormSelect from '../controls/forms/redesign/FormFilterSelect';
import { SelectItem } from 'src/models/common/SelectItem';
import User from 'src/models/User';
import PagedResultSet from 'src/models/common/PagedResultSet';
import ProjectAdministrationType, { ProjectAdministratorTypes } from 'src/models/ProjectAdministrationType';
import ProjectAdministratorStaff from 'src/models/ProjectAdministratorStaff';
import FormTextBox, { FormTextBoxDataType } from '../controls/forms/redesign/FormTextbox';
import { FormErrors } from 'src/util/FormErrors';
import { AnyObject } from 'final-form';
import { ODataOptions, ODataFilter, ODataFilterOperators } from 'src/util/ODataBuilder';
import { UserRoles } from 'src/models/UserRole';
import { UserTypes } from 'src/models/UserType';

export interface IAddStaffDialogProps {
    clientNumber: number;
    projectNumber: number;
    users: PagedResultSet<User>;
    projectAdministrationTypes: Array<ProjectAdministrationType>;
    dialogName: string;
    onCloseDialog: () => void;
    hideDialog: () => void;
    itemType: string;
    getProjAdminTypes: () => void;
    getUsersByOptions: (options: ODataOptions) => void;
    addUserToStaff: (clientId: number, projectId: number, staffInfo: ProjectAdministratorStaff) => void;
}

type AddStaffState = {
    selectedRole: number;
    selectedUserId: number;
};

type IAddStaffDialogPageProps = IAddStaffDialogProps;

class AddStaffDialog extends React.Component<IAddStaffDialogPageProps, AddStaffState> {
    constructor(props: IAddStaffDialogPageProps) {
        super(props);
    }

    private filterMemberSection = (item: SelectItem) => {
        this.setState({ selectedRole: item.id as number });
        const options = new ODataOptions();
        let filter;
        if (item.id === ProjectAdministratorTypes.ProspectManager) {
            filter = new ODataFilter('userRoleId', ODataFilterOperators.Equals, UserRoles.ProspectManager);
        } else if (item.id === ProjectAdministratorTypes.ProjectCoordinator) {
            filter = new ODataFilter('userRoleId', ODataFilterOperators.Equals, UserRoles.ProjectCoordinator);
        } else if (item.id === ProjectAdministratorTypes.CrewChief) {
            filter = new ODataFilter('userRoleId', ODataFilterOperators.Equals, UserRoles.Landman);
        } else if (item.id === ProjectAdministratorTypes.ClientLandman) {
            filter = new ODataFilter('userTypeId', ODataFilterOperators.Equals, UserTypes.ClientLandman);
        }
        options.addFilter(filter);

        this.props.getUsersByOptions(options);
    };

    private selectUserId = (id: number) => {
        this.setState({ selectedUserId: id });
    };

    private addUserToProject = (staffInfo: ProjectAdministratorStaff) => {
        this.props.hideDialog();
        this.props.addUserToStaff(this.props.clientNumber, this.props.projectNumber, staffInfo);
    };

    validate = (pmStaff: ProjectAdministratorStaff) => {
        const errors: FormErrors<ProjectAdministratorStaff> = {};
        errors.projectAdministrationType = {};
        errors.user = {};

        if (pmStaff.projectAdministrationType === undefined || pmStaff.projectAdministrationType.id === undefined) {
            errors.projectAdministrationType.id = 'Role is required';
        }

        if (pmStaff.user === undefined || pmStaff.user.id === undefined) {
            errors.user.id = 'User is required';
        }

        if (pmStaff.startDate === undefined) {
            errors.startDate = 'Start Date is required';
        }
        return errors as FormErrors<AnyObject>;
    };

    public render() {
        const roleItems = this.props.projectAdministrationTypes
            ? this.props.projectAdministrationTypes.map((type: ProjectAdministrationType) => new SelectItem(type.id, type.name))
            : undefined;

        const userSelectItems = this.props.users?.items?.map((user: User) => new SelectItem(user.id, `${user.firstName} ${user.lastName}`));

        return (
            <Dialog dialogName={this.props.dialogName} title={`Add Staff to Project`} onCloseDialog={this.props.onCloseDialog}>
                <div style={{ maxWidth: '40rem', maxHeight: '50rem' }}>
                    <Form onSubmit={this.addUserToProject} validate={this.validate}>
                        <div style={{ marginTop: '1.5rem' }}>
                            <FormSelect
                                name="projectAdministrationType.id"
                                label={`Role`}
                                items={roleItems}
                                onChange={(e) => this.filterMemberSection(roleItems.find((x) => x.id === e))}
                            />
                            <FormSelect
                                name="user.id"
                                label={`Select Staff Member`}
                                items={userSelectItems}
                                onChange={(e) => this.selectUserId(e as number)}
                            />
                            <FormTextBox label="Start Date" name="startDate" type={FormTextBoxDataType.Date} />
                        </div>

                        <div className="mt-2">
                            <Button text="Add Member" intent="primary" type="submit" />
                        </div>
                    </Form>
                </div>
            </Dialog>
        );
    }
}

export default AddStaffDialog;



// WEBPACK FOOTER //
// ./src/components/admin/AddStaffDialog.tsx